import { useState, useEffect } from 'react';
import '../../../entrydoor.css';
import { useGlassData } from './useGlassData';

const TexturedDesign = ({ value, onChange, id='TexturedDesign', label = 'Textured Design', disabled = false }) => {
    const defaultValue = value?.value || '';
    const [selectedTexturedDesign, setSelectedTexturedDesign] = useState(defaultValue);
    const { getTexturedDesigns, loading, error } = useGlassData();

    const options = getTexturedDesigns();

    // Update selected value when value prop changes
    useEffect(() => {
        setSelectedTexturedDesign(value?.value || '');
    }, [value]);

    // Trigger initial onChange once when options are loaded
    useEffect(() => {
        if (!loading && options.length > 0 && !selectedTexturedDesign) {
            const defaultOption = options[0];
            const newValue = defaultOption?.value || '';
            const newLabel = defaultOption?.label || '';
            setSelectedTexturedDesign(newValue);
            onChange({ value: newValue, label: newLabel });
        }
    }, [loading, options]);

    const handleTexturedDesignChange = (e) => {
        const newValue = e.target.value;
        const selectedText = e.target.options[e.target.selectedIndex].text.replace(' ✔', '');

        setSelectedTexturedDesign(newValue);
        onChange({ value: newValue, label: selectedText });
    };

    if (error) {
        console.error('Error loading textured design:', error);
    }

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor={id}>{label}</label>
            <select
                disabled={disabled || loading}
                id={id}
                value={selectedTexturedDesign}
                onChange={handleTexturedDesignChange}
            >
                {loading ? (
                    <option value="">Loading...</option>
                ) : (
                    options.map(opt => (
                        <option key={opt.id} value={opt.value}>
                            {selectedTexturedDesign === opt.value ? `${opt.label} ✔` : opt.label}
                        </option>
                    ))
                )}
            </select>
        </div>
    );
};

export default TexturedDesign;
